import Dexie from "dexie";
import * as Sentry from "@sentry/browser";
import { buildSchema } from "./helpers";
import { CollectionObjectsSchema, PendingMutationSchema } from "./schemas";

const DB_NAME = "nuorder";

function buildStore(schemas) {
    return schemas.reduce((acc, schema) => {
        acc[schema.collectionName] = buildSchema(schema);

        return acc;
    }, {});
}

function indexedDBInstance() {
    const dbInstance = new Dexie(DB_NAME);

    // Every change in the schema needs a version https://github.com/dexie/Dexie.js/issues/156#issuecomment-162558842
    dbInstance.version(1).stores(buildStore([PendingMutationSchema]));
    dbInstance.version(1.1).stores(buildStore([PendingMutationSchema, CollectionObjectsSchema]));

    dbInstance.open().catch((e) => {
        Sentry.captureException(e);
        // eslint-disable-next-line no-console
        console.error("Open failed: " + e.stack);
    });

    return dbInstance;
}

export default indexedDBInstance();
